import { MSAL_CONFIG } from '@/constants';
import { parseJwt } from './jwt';

/**
 * Validate if a token is still valid (not expired)
 */
export function validateToken(
  token: string | undefined,
  tokenExpires: string | undefined,
): boolean {
  if (!token) {
    return false;
  }

  // Method 1: Check stored token_expires (if available)
  if (tokenExpires) {
    const expiresDate = new Date(tokenExpires);
    const currentTime = new Date();
    const bufferMs = MSAL_CONFIG.TOKEN.VALIDATION_BUFFER_MS;
    const isTokenValid =
      expiresDate.getTime() > currentTime.getTime() + bufferMs;

    if (!isTokenValid) {
      return false;
    }
  }

  // Method 2: Also check JWT exp claim directly (more reliable)
  try {
    const tokenClaims = parseJwt(token);
    if (tokenClaims.exp) {
      const tokenExp =
        tokenClaims.exp * MSAL_CONFIG.TIME.MILLISECONDS_PER_SECOND;
      const currentTime = Date.now();
      const bufferMs = MSAL_CONFIG.TOKEN.VALIDATION_BUFFER_MS;
      const isTokenValid = tokenExp > currentTime + bufferMs;

      if (!isTokenValid) {
        return false;
      }
      return true;
    }

    // No exp claim in token - check if we have stored expiration
    if (!tokenExpires) {
      return false;
    }
    return true;
  } catch (error) {
    console.warn('Failed to parse token for validation:', error);
    // If we can't parse token but have stored expiration, use that
    if (!tokenExpires) {
      return false;
    }
    return true;
  }
}
